import { css } from '@stitches/core';
import { generateClassNames } from '@supabase/auth-ui-shared';
var messageDefaultStyles = css({
    fontFamily: '$bodyFontFamily',
    fontSize: '$baseInputSize',
    marginBottom: '$labelBottomMargin',
    display: 'block',
    textAlign: 'center',
    borderRadius: '0.375rem',
    padding: '1.5rem 1rem',
    lineHeight: '1rem',
    variants: {
        color: {
            "default": {
                color: '$messageText',
                backgroundColor: '$messageBackground',
                border: '1px solid $messageBorder'
            },
            danger: {
                color: '$messageTextDanger',
                backgroundColor: '$messageBackgroundDanger',
                border: '1px solid $messageBorderDanger'
            }
        }
    }
});
var Message = function (props) {
    var _a, _b;
    var classNames = generateClassNames('message', messageDefaultStyles({ color: props.color }), props.appearance);
    return (<span {...props} style={(_b = (_a = props.appearance) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.message} class={classNames.join(' ')}>
      {props.children}
    </span>);
};
export { Message };
